export default __webpack_public_path__ + "static/media/Fiche_Consciencieux.a3663a99.svg";